// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8a34a6e6","453":"e07e8b64","455":"4335b235"}[chunkId] + ".chunk.js";
};